import { v4 as uuidv4 } from 'uuid';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { navigateTo } from './navigation';

function fetchData(url: string, method: string, body: any) {
    return fetch(url, {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(body)
    })
    .then(response => response.json())
    .then(data => {
        return data;
    }
    )
    .catch((error) => {
        console.error('Error:', error);
        navigateTo('/login');
    }
    );
}

/*
fetch(`${BASE_URL}user`, {
    headers: {
        'Authorization': `Bearer ${token}`
    }
}).then(res => {
    if (res.status === 401) {
        navigate('/login');
    }
    return res.json();
})
.catch(() => {
    navigate('/login');
});
*/


function getUuidV4() {
    return uuidv4();
}

function formatDate(dataString: string) : string {
    if (!dataString) return "";
    const date = parseISO(dataString);
    return format(date, "dd/MM/yyyy", { locale: ptBR });    
   
}

function formatMoeda (valor: number, decimal: number = 2): string  {
    return parseFloat(valor.toString()).toLocaleString('pt-BR', 
        {
            currency: 'BRL', 
            minimumFractionDigits: decimal,
            maximumFractionDigits: decimal
        }
    )
}

function ajustarOrdenacaoPaginada(page: string | null, initOrderBy: any, setOrderBy: any) {
    if (page?.includes('ordering')) {
        const order = page.split('=')[1];
        if (order.includes('-')) {
            let name = order.split('-')[1];

            if (name.includes('page')) {
                name = name.split('&')[0];
            }

            if (name.includes('-')) {
                name.replace('-', '');
            }

            setOrderBy({
                ...initOrderBy,
                [name]: { name, order: 'asc', label: initOrderBy[name as keyof typeof initOrderBy].label }
            });
        } else {
            const name = order.includes('page') ? order.split('&')[0] : order;

            setOrderBy({
                ...initOrderBy,
                [name]: { name, order: '-', label: initOrderBy[name as keyof typeof initOrderBy].label }
            });
        }
    }
}


function handleNumberOnly(e: React.KeyboardEvent<HTMLInputElement>) {
    const element = e.target as HTMLInputElement;
    const value = element.value;
    const numberOnly = value.replace(/\D/ig, '');
    element.value = numberOnly;
    return numberOnly;
}

function handleNumberOnlyPositivo(e: React.KeyboardEvent<HTMLInputElement>) {
    const element = e.target as HTMLInputElement;
    const value = element.value;
    //const numberOnly = value.replace(/\^D/ig, '');
    const numberOnly = value.replace(/[^0-9]/g, "").replace(/^0+/, "")
    element.value = numberOnly;
}

function rgx_numberOnly(value: any) {
    return value.replace(/\D/ig, '');
}

function rgx_numberOnlyPositivo(value: any) {
    return value.replace(/[^0-9]/g, "").replace(/^0+/, "")
}

function upperCase(e: React.KeyboardEvent<HTMLInputElement>) {
    const element = e.target as HTMLInputElement;
    const value = element.value;
    const upper = value.toUpperCase()
    element.value = upper;
}

function lowerCase(e: React.KeyboardEvent<HTMLInputElement>) {
    const element = e.target as HTMLInputElement;
    const value = element.value;
    const lower = value.toLowerCase()
    element.value = lower;
}



function isNumber(value: string) {
    return /^\d+$/gi.test(value);
}

function isPlaca(value: string) {
    return /[A-Z]{2,3}[0-9]{4}|[A-Z]{3,4}[0-9]{3}|[A-Z0-9]{7}/.test(value)
}

function validarCPF(cpf: string): boolean {
    cpf = cpf.replace(/[^\d]/g, '');
    
    if (cpf.length !== 11) return false;
    
    let sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let digit = 11 - (sum % 11);
    if (digit >= 10) digit = 0;
    if (digit !== parseInt(cpf.charAt(9))) return false;
    
    sum = 0;
    for (let i = 0; i < 10; i++) {
        sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    digit = 11 - (sum % 11);
    if (digit >= 10) digit = 0;
    if (digit !== parseInt(cpf.charAt(10))) return false;
    
    return true;
}

function validarCNPJ(cnpj: string): boolean {
    cnpj = cnpj.replace(/[^\d]/g, '');
    
    if (cnpj.length !== 14) return false;
    
    let size = cnpj.length - 2;
    let numbers = cnpj.substring(0, size);
    let digits = cnpj.substring(size);
    let sum = 0;
    let pos = size - 7;
    
    for (let i = size; i >= 1; i--) {
        sum += parseInt(numbers.charAt(size - i)) * pos--;
        if (pos < 2) pos = 9;
    }
    
    let result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseInt(digits.charAt(0))) return false;
    
    size = size + 1;
    numbers = cnpj.substring(0, size);
    sum = 0;
    pos = size - 7;
    
    for (let i = size; i >= 1; i--) {
        sum += parseInt(numbers.charAt(size - i)) * pos--;
        if (pos < 2) pos = 9;
    }
    
    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseInt(digits.charAt(1))) return false;
    
    return true;
}

function validarCPFCNPJ(value: string) {
    if (value.length === 11) {
        return validarCPF(value);
    } else if (value.length === 14) {
        return validarCNPJ(value);
    }
    return false;
}


function tratarErrors(errors: any, prefixos: string[] ) {
    let listaErros = {};

    prefixos.forEach(prefixo => {
        let newObj = {};
        const errorsCustom = Object.fromEntries(
            Object.entries(errors).filter(([key]) => key.startsWith(prefixo))
        );
                
        const erroWithOut = Object.fromEntries(
            Object.entries(errors).filter(([key]) => !key.startsWith(prefixo))
        );
           
        if (Object.keys(errorsCustom).length > 0) {
           
            newObj = Object.entries(errorsCustom).reduce((acc: { [key: string]: any }, [key, value]) => {
                let newKey = key.replaceAll('.', '_');
                if (key.includes('.'))  {
                    acc[newKey] = value;
                    delete acc[key];
                }
                
                return acc;
            }, {});
        }
       
        listaErros = {...listaErros, ...erroWithOut, ...newObj}
        
    });
    
    return listaErros
}

function getPseudoID() {
    const agora = new Date();
    const ano = agora.getFullYear();
    const mes = String(agora.getMonth() + 1).padStart(2, "0");
    const dia = String(agora.getDate()).padStart(2, "0");
    const hora = String(agora.getHours()).padStart(2, "0");
    const minuto = String(agora.getMinutes()).padStart(2, "0");
    const segundo = String(agora.getSeconds()).padStart(2, "0");
    return parseInt(`${ano}${mes}${dia}${hora}${minuto}${segundo}`)
}

function strToFloat(value: string) {
    if (value === '') {
        value = '0'
    }
    return parseFloat(value.replace(/[^0-9.]/g, "").replace(/(\.\d{2})\d+/, "$1"))
}

const goToFocus = (value: React.RefObject<HTMLElement>) => {
    if (value.current) {
        value.current.focus()
    }
}

export { 
    formatDate, 
    formatMoeda, 
    ajustarOrdenacaoPaginada, 
    handleNumberOnly, 
    validarCPFCNPJ, 
    tratarErrors, 
    isNumber,
    isPlaca,
    lowerCase,
    upperCase,
    getPseudoID,
    strToFloat,
    validarCNPJ,
    getUuidV4,
    goToFocus,
    handleNumberOnlyPositivo,
    rgx_numberOnly,
    rgx_numberOnlyPositivo
} ;
